// offer dependant normalizers

// utils
function getProductArr(product, offer) {
  const res = product?.offers?.[offer] || [];

  return res;
}

function normalizeColor(product) {
  let res = {};

  res.hex = product?.colorHex || null;
  res.text = product?.colorName || null;
  res.code = product?.productSpecs?.color || null;

  if (!res.code) return null;

  return res;
}

function normalizePrice(product) {
  let res = {};

  res.av = product?.pvp_fusion_av || null;
  res.mv = product?.pvp_fusion_mv || null;
  res.bv = product?.pvp_fusion_bv || null;

  return res;
}

function normalizeStorage(product) {
  let res = {};

  res.code = product?.productSpecs?.storage || null;
  res.text = product?.storage || null;

  if (!res.code) return null;

  return res;
}

function normalizeAliasUrl(product) {
  return product?.aliasUrl;
}

export function normalizeProductOffer(product, productArr) {
  let res = {};

  res.imgs = product?.imgs || [];
  res.color = normalizeColor(product);
  res.price = normalizePrice(product);
  res.storage = normalizeStorage(product);
  res.aliasUrl = normalizeAliasUrl(product);

  return res;
}

// normalizers
export function normalizeOffers(products, offer) {
  let res = {};
  const productArr = getProductArr(products, offer);

  for (let offerProduct of productArr) {
    const alias = offerProduct?.alias;

    if (alias) {
      res[alias] = normalizeProductOffer(offerProduct, productArr);
    }
  }

  return res;
}

export function normalizeProductOffering(product, offer) {
  const res = getProductArr(product, offer)[0]?.productOffering || null;

  return res;
}

export function normalizeDefaultProductAlias(product, offer) {
  const res = getProductArr(product, offer)[0]?.alias || null;

  return res;
}
